import Repository from '../../repositories/RepositoryFactory';
const inventoryConsumables = Repository.get('inventoryConsumables');

export default {
	namespaced: true,
	state: {
		consumables: [],
		selectedConsumable: {},
		inventoryConsumableCategoryOptions: [],
	},
	mutations: {
		SET_CONSUMABLES (state, payload) {
			state.consumables = payload;
		},
		SET_CONSUMABLES_CATEGORY_OPTIONS (state, payload) {
			state.inventoryConsumableCategoryOptions = payload;
		},
		SET_CONSUMABLE (state, payload) {
			state.selectedConsumable = payload;
		},
		DELETE_CONSUMABLE (state, id) {
			state.consumables = state.consumables.filter((catalog) => catalog.id !== id);
			if (state.selectedConsumable.id === id) {
				state.selectedConsumable = {};
			}
		},
	},
	actions: {
		async getConsumables ({ commit }) {
			const result = await inventoryConsumables.getConsumables();
			commit('SET_CONSUMABLES', result);
			return result;
		},
		async getConsumableById ({ commit }, id) {
			const result = await inventoryConsumables.getConsumableById(id);
			commit('SET_CONSUMABLE', result);
		},
		async addConsumable ({ commit }, body) {
			const result = await inventoryConsumables.addConsumable(body);
			return result;
		},
		async editConsumable ({ commit }, body) {
			return await inventoryConsumables.editConsumable(body);
		},
		async deleteConsumable ({ commit }, id) {
			const resultDelete = await inventoryConsumables.deleteConsumable(id);
			commit('DELETE_CONSUMABLE', id);
			return resultDelete;
		},
		async getInventoryConsumableCategoryOptions ({ commit }) {
			const result = await inventoryConsumables.getInventoryConsumableCategoryOptions();
			commit('SET_CONSUMABLES_CATEGORY_OPTIONS', result);
			return result;
		},
		async getInventoryConsumableStatuses ({ commit }) {
			const result = await inventoryConsumables.getInventoryConsumableStatuses();
			return result;
		},
	},
};
